import { API_URL } from '../../../app-config/constants';
import { CompanyMiniExperiment } from '../../../types/ExperimentDto';
import { get } from '../request';

const ENTRY = `${API_URL}/experiment-observer`;

getCompanyExperiments.operation = 'READ';
export function getCompanyExperiments(companyId: string): Promise<CompanyMiniExperiment[]> {
    return get(`${ENTRY}/experiments/company/${companyId}`);
}
